<template>
  <div class="crm-management-dashboard">
    <h1>CRM Management Dashboard</h1>
    <div class="dashboard-top-actions">
      <b-button variant="primary" @click="openKanbanPage">
        Open Kanban
      </b-button>
    </div>
    <!-- Global filters will go here -->
    <b-row class="row-spacing">
      <b-col cols="12" class="portlet-wrapper">
        <b-card no-body class="portlet">
          <div class="portlet-header">
            <h3 class="text-white">Global Filters</h3>
            
            <div class="portlet-actions">
              
            </div>
          </div>
          <b-card-body class="portlet-body">
            <GlobalFilterBar
              :base-api="baseApi"
              :access-token="accessToken"
              @filters-changed="handleFiltersChanged"
              @search="handleSearch"
            />
          <div v-if="isDashboardLoading">
            <b-spinner variant="primary" label="Loading dashboard"></b-spinner>
          </div>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <!-- Dashboard sections: single API load; use-aggregate stops each child from calling API -->
     <b-row class="row-spacing">
      <b-col cols="12" lg="6" class="portlet-wrapper">
        
        <b-card no-body class="portlet">
          <div class="portlet-header">
            <h3 class="text-white"> Realtime KPIs</h3>
            <div class="portlet-actions">
              
            </div>
          </div>
        <RealtimeKpiStrip :filters="filters" :user="user" :dashboard-data="dashboardData" :use-aggregate="true" :base-api="baseApi" :access-token="accessToken" @kpi-card-click="handleRealtimeKpiClick" />
        </b-card>
      </b-col>
      <b-col cols="12" lg="6" class="portlet-wrapper">
        <b-card no-body class="portlet">
          <div class="portlet-header">
            <h3 class="text-white"> Presales Pipeline</h3>
            <div class="portlet-actions">
              
            </div>
          </div>
        <PresalesPipeline :filters="filters" :user="user" :dashboard-data="dashboardData" :use-aggregate="true" :base-api="baseApi" :access-token="accessToken" @presales-card-click="handlePresalesDrilldown" />
        </b-card>
      </b-col>
      
    </b-row>

    <b-row class="row-spacing">
      <b-col cols="12" lg="12" class="portlet-wrapper">
        <b-card no-body class="portlet">
          <div class="portlet-header">
            <h3 class="text-white"> Sales Pipeline</h3>
            <div class="portlet-actions">
              
            </div>
          </div>
            <SalesPipeline :filters="filters" :user="user" :dashboard-data="dashboardData" :use-aggregate="true" :base-api="baseApi" :access-token="accessToken" @sales-card-click="handleSalesDrilldown" />
        </b-card>
      </b-col>
    </b-row>

    
    <b-row class="row-spacing">
  <b-col cols="12" md="6" lg="6" class="portlet-wrapper">
    <b-card no-body class="portlet">
      <div class="portlet-header">
        <h3 class="text-white"> Sales by Stage</h3>
        <div class="portlet-actions">
          
        </div>
      </div>
    <SalesStageChart :filters="filters" :user="user" :dashboard-data="dashboardData" :use-aggregate="true" :base-api="baseApi" :access-token="accessToken" @chart-point-click="handleSalesStageChartClick" />
    </b-card>
  </b-col>
  <b-col cols="12" md="6" lg="6" class="portlet-wrapper">
    <b-card no-body class="portlet">
      <div class="portlet-header">
        <h3 class="text-white"> Number of Leads vs Lead Stage</h3>
        <div class="portlet-actions">
          
        </div>
      </div>
    <FullFunnelChart :filters="filters" :user="user" :dashboard-data="dashboardData" :use-aggregate="true" :base-api="baseApi" :access-token="accessToken" @chart-point-click="handleFullFunnelChartClick" />
    </b-card>
  </b-col>
  </b-row>
            <b-row class="row-spacing">
              <b-col cols="4" lg="4" class="row-spacing">
        <b-card no-body class="portlet">
          <div class="portlet-header">
            <h3 class="text-white"> Top Telecallers</h3>
          </div>
            <TelecallerLeaderboard :filters="filters" :user="user" :dashboard-data="dashboardData" :use-aggregate="true" :base-api="baseApi" :access-token="accessToken" />
            </b-card>
            </b-col>
            <b-col cols="4" lg="4"  class="row-spacing">
        <b-card no-body class="portlet" >
          <div class="portlet-header">
            <h3 class="text-white"> Top Sales Managers</h3>
          </div>
            <SmLeaderboard :filters="filters" :user="user" :dashboard-data="dashboardData" :use-aggregate="true" :base-api="baseApi" :access-token="accessToken" />
            </b-card>
            </b-col>
            <b-col cols="4" lg="4" class="row-spacing">
        <b-card no-body class="portlet">
          <div class="portlet-header">
            <h3 class="text-white"> Lead Source ROI</h3>
          </div>
            <LeadSourceRoi :filters="filters" :user="user" :dashboard-data="dashboardData" :use-aggregate="true" :base-api="baseApi" :access-token="accessToken" />
            </b-card>
            </b-col>
            <b-col cols="4" lg="4" class="row-spacing">
        <b-card no-body class="portlet">
          <div class="portlet-header">
            <h3 class="text-white"> Pending Followups</h3>
          </div>
            <PendingFollowups :filters="filters" :user="user" :dashboard-data="dashboardData" :use-aggregate="true" :base-api="baseApi" :access-token="accessToken" />
            </b-card>
            </b-col>
            <b-col cols="4" lg="4" class="row-spacing">
        <b-card no-body class="portlet">
          <div class="portlet-header">
            <h3 class="text-white"> Upcoming Site Visits</h3>
          </div>
            <UpcomingSiteVisits :filters="filters" :user="user" :dashboard-data="dashboardData" :use-aggregate="true" :base-api="baseApi" :access-token="accessToken" />
            </b-card>
            </b-col>
            <b-col cols="4" lg="4" class="row-spacing">
        <b-card no-body class="portlet">
          <div class="portlet-header">
            <h3 class="text-white"> Project-wise Sales Summary
            </h3>
          </div>
            <ProjectPerformance :filters="filters" :user="user" :dashboard-data="dashboardData" :use-aggregate="true" :base-api="baseApi" :access-token="accessToken" />
            </b-card>
            </b-col>
            </b-row>

    <b-row class="row-spacing">
      <b-col cols="12" md="6">
        <b-row class="">
      <b-col cols="12" md="12">
        <b-card no-body class="portlet">
          <div class="portlet-header">
            <h3 class="text-white"> Monthly Lead & Closure Trend</h3>
            <div class="portlet-actions">
    
            </div>
          </div>
        <MonthlyTrendChart :filters="filters" :user="user" :dashboard-data="dashboardData" :use-aggregate="true" :base-api="baseApi" :access-token="accessToken" @chart-point-click="handleMonthlyTrendChartClick" />
        </b-card>
      </b-col>  
      <b-col cols="12" md="12">
        <b-card no-body class="portlet">
          <div class="portlet-header">
            <h3 class="text-white"> Conversion Rate</h3>
            <div class="portlet-actions">
    
            </div>
          </div>
        <ConversionRateChart :filters="filters" :user="user" :dashboard-data="dashboardData" :use-aggregate="true" :base-api="baseApi" :access-token="accessToken" @chart-point-click="handleConversionRateChartClick" />
        </b-card>
      </b-col>
      </b-row>
      </b-col>
      <b-col cols="12" md="6">
        <b-card no-body class="portlet">
          <div class="portlet-header">
            <h3 class="text-white"> Lead Source Pie Chart</h3>
            <div class="portlet-actions">
    
            </div>
          </div>
        <LeadSourcePieChart :filters="filters" :user="user" :dashboard-data="dashboardData" :use-aggregate="true" :base-api="baseApi" :access-token="accessToken" @chart-point-click="handleLeadSourcePieChartClick" />
        </b-card>
      </b-col>
    </b-row>
    <b-row class="row-spacing">
      <b-col cols="12" md="6">
        
        <b-card no-body class="portlet">
          <div class="portlet-header">
            <h3 class="text-white"> Presales Daily Chart</h3>
            <div class="portlet-actions">
    
            </div>
          </div>
        <PresalesDailyChart :filters="filters" :user="user" :dashboard-data="dashboardData" :use-aggregate="true" :base-api="baseApi" :access-token="accessToken" @chart-point-click="handlePresalesDailyChartClick" />
        </b-card>
      
      </b-col>
      <b-col cols="12" md="6">
        <b-card no-body class="portlet">
          <div class="portlet-header">
            <h3 class="text-white"> Revenue Trend Chart</h3>
            <div class="portlet-actions">
    
            </div>
          </div>
        <RevenueTrendChart :filters="filters" :user="user" :dashboard-data="dashboardData" :use-aggregate="true" :base-api="baseApi" :access-token="accessToken" @chart-point-click="handleRevenueTrendChartClick" />
        </b-card>
      </b-col>
    </b-row>

    <!-- Drill-down Modals -->
    <PresalesDrillModal
      :visible.sync="presalesDrillModalVisible"
      :drilldownLevel="currentDrilldownLevel"
      :filters="filters"
      :leadId="currentLeadId"
      :base-api="baseApi"
      :access-token="accessToken"
    />
    <SalesDrillModal
      :visible.sync="salesDrillModalVisible"
      :drilldownLevel="currentDrilldownLevel"
      :filters="filters"
      :saleId="currentSaleId"
      :base-api="baseApi"
      :access-token="accessToken"
    />

    <DashboardDetailModal
      :widget-title="detailWidgetTitle"
      :detail-endpoint="detailEndpoint"
      :detail-params="detailParams"
      :filters="filters"
      :visible.sync="detailModalVisible"
      @modal-closed="closeDetailModal"
    />

  </div>
</template>

<script>
import GlobalFilterBar from '@/components/dashboard/GlobalFilterBar.vue';
import RealtimeKpiStrip from '@/components/dashboard/RealtimeKpiStrip.vue';
import PresalesPipeline from '@/components/dashboard/PresalesPipeline.vue';
import PresalesDailyChart from '@/components/dashboard/PresalesDailyChart.vue';
import SalesPipeline from '@/components/dashboard/SalesPipeline.vue';
import SalesStageChart from '@/components/dashboard/SalesStageChart.vue';
import FullFunnelChart from '@/components/dashboard/FullFunnelChart.vue';
import ConversionRateChart from '@/components/dashboard/ConversionRateChart.vue';
import LeadSourcePieChart from '@/components/dashboard/LeadSourcePieChart.vue';
import MonthlyTrendChart from '@/components/dashboard/MonthlyTrendChart.vue';
import RevenueTrendChart from '@/components/dashboard/RevenueTrendChart.vue';
import TelecallerLeaderboard from '@/components/dashboard/TelecallerLeaderboard.vue';
import SmLeaderboard from '@/components/dashboard/SmLeaderboard.vue';
import LeadSourceRoi from '@/components/dashboard/LeadSourceRoi.vue';
import PendingFollowups from '@/components/dashboard/PendingFollowups.vue';
import UpcomingSiteVisits from '@/components/dashboard/UpcomingSiteVisits.vue';
import ProjectPerformance from '@/components/dashboard/ProjectPerformance.vue';
import PresalesDrillModal from '@/components/dashboard/PresalesDrillModal.vue';
import SalesDrillModal from '@/components/dashboard/SalesDrillModal.vue';
import DashboardDetailModal from '@/components/dashboard/DashboardDetailModal.vue';
import { BRow, BCol, BCard, BCardBody ,BSpinner, BButton } from 'bootstrap-vue';
import axios from 'axios';

export default {
  name: 'CrmManagementDashboard',
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BSpinner,
    BButton,
    GlobalFilterBar,
    RealtimeKpiStrip,
    PresalesPipeline,
    PresalesDailyChart,
    SalesPipeline,
    SalesStageChart,
    FullFunnelChart,
    ConversionRateChart,
    LeadSourcePieChart,
    MonthlyTrendChart,
    RevenueTrendChart,
    TelecallerLeaderboard,
    SmLeaderboard,
    LeadSourceRoi,
    PendingFollowups,
    UpcomingSiteVisits,
    ProjectPerformance,
    PresalesDrillModal,
    SalesDrillModal,
    DashboardDetailModal,
  },
  data() {
    return {
      baseApi: process.env.VUE_APP_APIENDPOINT,
      accessToken: localStorage.getItem('accessToken'),
      filters: {}, // Initialize filters
      dashboardData: {}, // Single load from /dashboard/crm/all
      presalesDrillModalVisible: false,
      salesDrillModalVisible: false,
      currentDrilldownLevel: '',
      currentLeadId: null,
      currentSaleId: null,
      user: null, // User data for role-based access
      _dashboardFetchTimer: null, // Debounce timer

      // New detail modal state
      detailModalVisible: false,
      isDashboardLoading: false,
      detailWidgetTitle: '',
      detailEndpoint: '',
      detailParams: {},
      initialDashboardFetched: false,
    };
  },
  methods: {
    hasSelectedEmployeeFilter() {
      return (
        this.filters &&
        this.filters.employee_id !== null &&
        this.filters.employee_id !== undefined &&
        this.filters.employee_id !== ''
      );
    },
    handleFiltersChanged(newFilters) {
      this.filters = newFilters;
      if (!this.initialDashboardFetched) {
        this.initialDashboardFetched = true;
        this.debouncedFetchDashboard();
      }
    },
    handleSearch(newFilters) {
      this.filters = newFilters;
      this.debouncedFetchDashboard(true);
    },
    openKanbanPage() {
      this.$router.push({ name: 'crm-management-kanban' });
    },
    async debouncedFetchDashboard(forceRefresh = false) {
      if (this._dashboardFetchTimer) clearTimeout(this._dashboardFetchTimer);
      this._dashboardFetchTimer = setTimeout(async () => {
        this._dashboardFetchTimer = null;
        this.isDashboardLoading = true;
        await this.fetchDashboardData(forceRefresh);
        this.isDashboardLoading = false;
      }, 400);
    },
    async fetchDashboardData(forceRefresh = false) {
      if (!this.baseApi || !this.accessToken) return;
      try {
        const params = { ...this.filters };
        if (forceRefresh) {
          params.refresh = 1;
        }
        const response = await axios.get(`${this.baseApi}/dashboard/crm/all`, {
          params,
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${this.accessToken}`,
          },
        });
        if (response.data && response.data.data) {
          this.dashboardData = response.data.data;
        }
      } catch (error) {
        console.error('Error fetching dashboard data:', error);
        // Keep previous dashboardData so charts/tables don't flash blank
        if (!this.dashboardData) this.dashboardData = {};
      } finally {
      }
    },
    openPresalesDrillModal(level, leadId = null) {
      this.currentDrilldownLevel = level;
      this.currentLeadId = leadId;
      this.presalesDrillModalVisible = true;
    },
    openSalesDrillModal(level, saleId = null) {
      this.currentDrilldownLevel = level;
      this.currentSaleId = saleId;
      this.salesDrillModalVisible = true;
    },
    handlePresalesDrilldown(cardKey) {
      let widgetTitle = '';
      let detailEndpoint = '';
      let detailParams = {};

      switch (cardKey) {
        case 'total_leads':
          widgetTitle = 'Presales - Total Leads';
          
          detailEndpoint = '/dashboard/crm/presales-pipeline/detail/total_leads';
          break;
        case 'total_calls_done':
          widgetTitle = 'Presales - Total Calls Done';
          detailEndpoint = '/dashboard/crm/presales-pipeline/detail/total_calls_done';
          break;
        case 'connected_calls':
          widgetTitle = 'Presales - Connected Calls';
          detailEndpoint = '/dashboard/crm/presales-pipeline/detail/connected_calls';
          break;
        case 'qualified_interested_leads':
          widgetTitle = 'Presales - Interested Leads (status: Interested)';
          detailEndpoint = '/dashboard/crm/presales-pipeline/detail/qualified_interested_leads';
          break;
        case 'in_progress_leads':
          widgetTitle = 'Presales - In Progress Leads';
          detailEndpoint = '/dashboard/crm/presales-pipeline/detail/in_progress_leads';
          break;
        case 'site_visit_interested':
          widgetTitle = 'Presales - Site Visit Interested';
          detailEndpoint = '/dashboard/crm/presales-pipeline/detail/site_visit_interested';
          break;
        default:
          console.warn('Unknown presales card key for drilldown:', cardKey);
          return;
      }
      this.openDetailModal(widgetTitle, detailEndpoint, detailParams);
    },
    handleSalesDrilldown(cardKey) {
      let widgetTitle = '';
      let detailEndpoint = '';
      let detailParams = {};

      switch (cardKey) {
        case 'total_closures':
          widgetTitle = 'Sales - Total Closures';
          detailEndpoint = '/dashboard/crm/sales-pipeline/detail/total_closures';
          break;
        case 'closure_value':
          widgetTitle = 'Sales - Closure Value';
          detailEndpoint = '/dashboard/crm/sales-pipeline/detail/closure_value';
          break;
        case 'total_bookings_done':
          widgetTitle = 'Sales - Total Bookings Done';
          detailEndpoint = '/dashboard/crm/sales-pipeline/detail/total_bookings_done';
          break;
        case 'booking_value':
          widgetTitle = 'Sales - Booking Value';
          detailEndpoint = '/dashboard/crm/sales-pipeline/detail/booking_value';
          break;
        case 'site_visit_done':
          widgetTitle = 'Sales - Site Visits Done';
          detailEndpoint = '/dashboard/crm/sales-pipeline/detail/site_visit_done';
          break;
        case 'prospects_received':
          widgetTitle = 'Sales - Prospects Received';
          detailEndpoint = '/dashboard/crm/sales-pipeline/detail/prospects_received';
          break;
        case 'closure_meeting':
          widgetTitle = 'Sales - Closure Meeting';
          detailEndpoint = '/dashboard/crm/sales-pipeline/detail/closure_meeting';
          break;
        case 'negotiation':
          widgetTitle = 'Sales - Negotiation';
          detailEndpoint = '/dashboard/crm/sales-pipeline/detail/negotiation';
          break;
        case 'final_closure_retail':
          widgetTitle = 'Sales - Final Closure (Retail)';
          detailEndpoint = '/dashboard/crm/sales-pipeline/detail/final_closure_retail';
          break;
        case 'final_closure_bulk':
          widgetTitle = 'Sales - Final Closure (Bulk)';
          detailEndpoint = '/dashboard/crm/sales-pipeline/detail/final_closure_bulk';
          break;
        default:
          console.warn('Unknown sales card key for drilldown:', cardKey);
          return;
      }
      this.openDetailModal(widgetTitle, detailEndpoint, detailParams);
    },

    openDetailModal(widgetTitle, detailEndpoint, detailParams = {}) {
      this.detailWidgetTitle = widgetTitle;
      this.detailEndpoint = detailEndpoint;
      this.detailParams = detailParams;
      this.detailModalVisible = true;
    },
    closeDetailModal() {
      this.detailModalVisible = false;
      this.detailWidgetTitle = '';
      this.detailEndpoint = '';
      this.detailParams = {};
    },
    handleRealtimeKpiClick(kpiKey) {
      let widgetTitle = '';
      let detailEndpoint = '';
      let detailParams = {}; // Initialize detailParams

      switch (kpiKey) {
        case 'new_leads':
          widgetTitle = 'New Leads (no follow-up yet)';
          detailEndpoint = '/dashboard/crm/realtime-kpi/detail/new-leads-by-user';
          detailParams = { drillDetailEndpoint: '/dashboard/crm/realtime-kpi/detail/new-leads' };
          break;
        case 'total_calls':
          widgetTitle = 'Total Calls';
          // When employee filter is already selected, open direct detail endpoint
          // so modal rows match KPI count exactly.
          if (this.hasSelectedEmployeeFilter()) {
            detailEndpoint = '/dashboard/crm/realtime-kpi/detail/total-calls';
            detailParams = {};
          } else {
            detailEndpoint = '/dashboard/crm/realtime-kpi/detail/total-calls-by-user';
            detailParams = { drillDetailEndpoint: '/dashboard/crm/realtime-kpi/detail/total-calls' };
          }
          break;
        case 'site_visits':
          widgetTitle = 'Site Visits';
          detailEndpoint = '/dashboard/crm/realtime-kpi/detail/site-visits';
          break;
        case 'closures':
          widgetTitle = 'Closures';
          detailEndpoint = '/dashboard/crm/realtime-kpi/detail/closures';
          break;
        case 'not_connected_calls':
          widgetTitle = 'Not Connected Call';
          detailEndpoint = '/dashboard/crm/realtime-kpi/detail/not-connected';
          break;
        case 'priority_leads':
          widgetTitle = 'Priority Leads (Hot / Warm / Cold)';
          detailEndpoint = '/dashboard/crm/realtime-kpi/detail/priority-leads';
          break;
        case 'lost_leads':
          widgetTitle = 'Lost';
          detailEndpoint = '/dashboard/crm/realtime-kpi/detail/lost';
          break;
        case 'transfer_to_sales':
          widgetTitle = 'Transfer to Sales';
          detailEndpoint = '/dashboard/crm/realtime-kpi/detail/transfer-to-sales';
          break;
        default:
          console.warn('Unknown KPI key for detail:', kpiKey);
          return;
      }
      this.openDetailModal(widgetTitle, detailEndpoint, detailParams);
    },
    handleSalesStageChartClick(widgetTitle, detailEndpoint, detailParams) {
      this.openDetailModal(widgetTitle, detailEndpoint, detailParams);
    },
    handleFullFunnelChartClick(widgetTitle, detailEndpoint, detailParams) {
      this.openDetailModal(widgetTitle, detailEndpoint, detailParams);
    },
    handleMonthlyTrendChartClick(widgetTitle, detailEndpoint, detailParams) {
      this.openDetailModal(widgetTitle, detailEndpoint, detailParams);
    },
    handleConversionRateChartClick(widgetTitle, detailEndpoint, detailParams) {
      this.openDetailModal(widgetTitle, detailEndpoint, detailParams);
    },
    handleLeadSourcePieChartClick(widgetTitle, detailEndpoint, detailParams) {
      this.openDetailModal(widgetTitle, detailEndpoint, detailParams);
    },
    handleRevenueTrendChartClick(widgetTitle, detailEndpoint, detailParams) {
      this.openDetailModal(widgetTitle, detailEndpoint, detailParams);
    },
    handlePresalesDailyChartClick(widgetTitle, detailEndpoint, detailParams) {
      this.openDetailModal(widgetTitle, detailEndpoint, detailParams);
    },
    async fetchUserData() {
      try {
        const response = await axios.get(`${this.baseApi}/user/profile`, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${this.accessToken}`,
          },
        });
        this.user = response.data.user;
      } catch (error) {
        console.error('Error fetching user data:', error);
        // Fallback: use userData from localStorage if available
        try {
          const userData = JSON.parse(localStorage.getItem('userData') || '{}');
          this.user = userData && Object.keys(userData).length ? userData : { role: 'admin', userrights: [{ module: 'dashboard', all_data: 1 }] };
        } catch (e) {
          this.user = { role: 'admin', userrights: [{ module: 'dashboard', all_data: 1 }] };
        }
      }
    },
  },
  mounted() {
    this.fetchUserData();
  },
  beforeDestroy() {
    if (this._dashboardFetchTimer) clearTimeout(this._dashboardFetchTimer);
  },
};
</script>

<style scoped>
.crm-management-dashboard {
  /* Basic styling for the dashboard container */
  padding: 20px;
}

.dashboard-top-actions {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 12px;
}

/* Modern Portlet Styles */

.row-spacing {
  margin-top: 20px;
  margin-bottom: 20px;
}

.portlet {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 6px 18px rgba(0,0,0,0.08);
  overflow: hidden;
  transition: 0.3s ease;
  height: 100%; /* Ensure portlet takes full height of its column */
  display: flex;
  flex-direction: column;
}

.portlet:hover {
  transform: translateY(-5px);
  box-shadow: 0 12px 24px rgba(0,0,0,0.12);
}

.portlet-header {
  padding: 6px;
  background: linear-gradient(135deg, #4e73df, #224abe);
  color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.portlet-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
}

.portlet-actions button {
  background: rgba(255,255,255,0.2);
  border: none;
  color: #fff;
  padding: 6px 10px;
  border-radius: 6px;
  cursor: pointer;
}

.portlet-body {
  padding: 20px;
  color: #555;
  font-size: 14px;
  flex-grow: 1; /* Allow body to take available space */
  overflow-y: auto; /* Enable scrolling if content overflows */
}

/* Specific adjustments for embedded components inside the portlet body */
.portlet-body > div { /* Target direct children div (e.g. wrapper of component) */
  margin-bottom: 15px; /* Add some space between embedded components */
  border-bottom: 1px solid #eee; /* Optional: Separator line */
  padding-bottom: 15px;
}

.portlet-body > div:last-child {
  margin-bottom: 0;
  border-bottom: none;
  padding-bottom: 0;
}

.portlet-footer {
  padding: 12px 20px;
  background: #f8f9fc;
  font-size: 13px;
  color: #777;
  border-top: 1px solid #eee;
}
</style>